import React, { useEffect, useState } from 'react';
import { apiGetCategory } from '@services/ManageDevices/DeviceServices';
import { Select } from 'antd';

const mapListToOptions = (data) => {
  return data
    ?.map((item) => ({
      value: item.value,
      label: item.name,
      ...item
    }))
    .sort((a, b) => a?.label?.localeCompare(b?.label, 'vi', { sensitivity: 'base' }));
};

export const SelectBranch = ({ disabled = false, onChange, value }) => {
  const [options, setOptions] = useState([]);

  const handleChange = (value, option) => {
    onChange && onChange(value, option);
  };

  const fetchOptions = async (valueSearch) => {
    const response = await apiGetCategory({
      keyword: valueSearch === '' ? undefined : valueSearch,
      type: 'CN'
    });
    setOptions(mapListToOptions(response?.data?.data));
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const selected = options.find(({ value: itemValue }) => value === itemValue);

  return (
    <Select
      style={{ width: '100%', height: '36px' }}
      cacheOptions
      isDisabled={disabled}
      options={options}
      placeholder="Chọn chi nhánh"
      loadOptions={fetchOptions}
      value={selected}
      onChange={handleChange}
    />
  );
};
